import { render, staticRenderFns } from "./house.vue?vue&type=template&id=bd409ca6&scoped=true&"
import script from "./house.vue?vue&type=script&lang=js&"
export * from "./house.vue?vue&type=script&lang=js&"
import style0 from "./house.vue?vue&type=style&index=0&id=bd409ca6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd409ca6",
  null
  
)

export default component.exports